/**
 * 오토탭 속도. 수치가 작을수록 빠르다. 기준속도 * 오토탭 속도 값 만큼 대기
 */
export enum AutoTapSpeed {
  Slow = 1.25,
  Normal = 1,
  Fast = 0.75,
  /**
   * 앱과 통신하기 위한 특수 값.오토탭 정지 상태를 의미한다.
   * 웹 내부에서는 AutoTapType으로 구분하므로 쓸 일이 없다.
   * 뷰어 로드 시점에 오토탭을 바로 시작할 지 여부를 앱과 통신해서 결정하는데, 이 때 오토탭 속도가 0이면 오토탭을 진행하지 않는 것으로 판단하고 있다.
   */
  None = 0,
}
